<template>
  <div>
    <table class="detail-tab" cellpadding="15">
      <tbody>
        <tr>
          <td>姓名:</td>
          <td>{{ state.model.name }}</td>
          <td>性别:</td>
          <td>{{ state.model.sex }}</td>
          <td>联系电话:</td>
          <td>{{ state.model.phone }}</td>
          <td>证件信息:</td>
          <td>
            {{ state.model.idcard }}
          </td>
        </tr>
        <tr>
          <td>在职状态:</td>
          <td :style="{ color: state.model.status == 0 ? '#f00' : '#1e90ff' }">
            {{ state.model.status == 0 ? "离职" : "在职" }}
          </td>
          <td>属性:</td>
          <td>{{ state.model.property == 0 ? "雇员" : "其他" }}</td>
          <td>入职时间:</td>
          <td>{{ state.model.entry_time || "-" }}</td>
          <td>离职时间:</td>
          <td>{{ state.model.resignation_time || "-" }}</td>
        </tr>
        <tr>
          <td>扣缴义务人:</td>
          <td colspan="3">{{ state.model.withholding_agent_name || "-" }}</td>
          <td>发薪单位:</td>
          <td colspan="3">{{ state.model.customer_name || "-" }}</td>
        </tr>
        <tr>
          <td>专属客服:</td>
          <td>{{ state.model.belonger_name || "-" }}</td>
          <td>签约单位:</td>
          <td>{{ state.model.contract_unit_name || "-" }}</td>
        </tr>
      </tbody>
    </table>
    <div style="padding: 20px">
      <ul
        style="
          font-weight: 600;
          font-size: 14px;
          padding-bottom: 10px;
          border-bottom: 1px solid #e2e2e2;
        "
      >
        账户信息
      </ul>
      <table class="detail-tab" cellpadding="15">
        <tbody>
          <tr>
            <td>收款账户开户行:</td>
            <td>{{ state.model.opening_bank || "-" }}</td>
            <td>账号:</td>
            <td colspan="3">{{ state.model.bank_account || "-" }}</td>
            <td>是否异卡:</td>
            <td>{{ state.model.is_diff_bank ? "是" : "否" }}</td>
            <td>户名:</td>
            <td style="width: 200px">
              {{ state.model.bank_account_name || "-" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_detail } from "@/http/api";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      employee_detail(props.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    });
    return { state };
  },
};
</script>
<style scoped lang="less">
.detail-tab {
  & > tbody > tr > td:first-child {
    width: 150px;
  }
}
</style>
